import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _3kIcon(props: IconProps) {
    return <Icon {...props} iconKey={"3k"}/>
}
